<template>
    <div class="row">
        <div class="col-xl-3 col-md-6">
            <!-- card -->
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 overflow-hidden">
                            <p class="text-uppercase fw-medium text-muted text-truncate mb-0">فروش کل</p>
                        </div>
                        <div class="flex-shrink-0" v-if="false">
                            <h5 class="text-success fs-14 mb-0">
                                <i class="ri-arrow-right-up-line fs-13 align-middle"></i>
                                +16.24 %
                            </h5>
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 v-if="!widgetsIsLoading" class="fs-22 fw-semibold ff-secondary mb-4">
                                <count-to :startVal='0' :endVal='parseInt(statistics.orders_total)' :duration='5000'></count-to> تومان
                            </h4>
                            <h4 v-else class="fs-22 fw-semibold ff-secondary mb-4">
                                <Skeletor style="width: 100px;" />
                            </h4>
                        </div>
                        <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-soft-success rounded fs-3">
                        <i class="bx bx-dollar-circle text-success"></i>
                      </span>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->

        <div class="col-xl-3 col-md-6">
            <!-- card -->
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 overflow-hidden">
                            <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                درامد کل
                            </p>
                        </div>
                        <div v-if="false" class="flex-shrink-0">
                            <h5 class="text-danger fs-14 mb-0">
                                <i class="ri-arrow-right-down-line fs-13 align-middle"
                                ></i>
                                -3.57 %
                            </h5>
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 v-if="!widgetsIsLoading" class="fs-22 fw-semibold ff-secondary mb-4">
                                <count-to :startVal='0' :endVal='statistics.orders_income' :duration='5000'></count-to> تومان
                            </h4>
                            <h4 v-else class="fs-22 fw-semibold ff-secondary mb-4">
                                <Skeletor style="width: 100px;" />
                            </h4>
                        </div>
                        <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-soft-info rounded fs-3">
                        <i class="bx bx-shopping-bag text-info"></i>
                      </span>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->

        <div class="col-xl-3 col-md-6">
            <!-- card -->
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 overflow-hidden">
                            <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                تعداد کل سفارش‌ها
                            </p>
                        </div>
                        <div v-if="false" class="flex-shrink-0">
                            <h5 class="text-success fs-14 mb-0">
                                <i
                                    class="ri-arrow-right-up-line fs-13 align-middle"
                                ></i>
                                +29.08 %
                            </h5>
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 v-if="!widgetsIsLoading" class="fs-22 fw-semibold ff-secondary mb-4">
                                <count-to :startVal='0' :endVal='statistics.orders_count' :duration='5000'></count-to>
                            </h4>
                            <h4 v-else class="fs-22 fw-semibold ff-secondary mb-4">
                                <Skeletor style="width: 100px;" />
                            </h4>
                        </div>
                        <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-soft-warning rounded fs-3">
                        <i class="bx bx-user-circle text-warning"></i>
                      </span>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->

        <div class="col-xl-3 col-md-6">
            <!-- card -->
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 overflow-hidden">
                            <p
                                class="text-uppercase fw-medium text-muted text-truncate mb-0"
                            >
                                موجودی قابل برداشت
                            </p>
                        </div>
                        <div v-if="false" class="flex-shrink-0">
                            <h5 class="text-muted fs-14 mb-0">+0.00 %</h5>
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 v-if="!widgetsIsLoading" class="fs-22 fw-semibold ff-secondary mb-4">
                                <count-to :startVal='0' :endVal='statistics.current_balance' :duration='5000'></count-to> تومان
                            </h4>
                            <h4 v-else class="fs-22 fw-semibold ff-secondary mb-4">
                                <Skeletor style="width: 100px;" />
                            </h4>
                        </div>
                        <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-soft-primary rounded fs-3">
                        <i class="bx bx-wallet text-primary"></i>
                      </span>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end row-->
</template>

<script>
import { CountTo } from "vue3-count-to";
import { Skeletor } from "vue-skeletor";

export default {
    name: "dashboard-widgets.vue",
    props: ['statistics', 'widgetsIsLoading'],
    data() {
        return [

        ];
    },
    components: {
        CountTo,
        Skeletor
    }
}
</script>

<style scoped>

</style>
